/* ═══════════════════════════════════════════════════════════
   ZAGARA CART — lux-cart.js
   Uses Shopify AJAX Cart API as source of truth.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var I18N = (window.ZAGARA && window.ZAGARA.i18n) || {};
  /* Nome e sottotitolo del prodotto: la funzione vive in luxury.js
     (window.ZAGARA.splitTitle, unica copia JS, specchio di zg-product-title).
     Guardia: se manca, nome intero e nessun sottotitolo — mai una riga vuota.
     product_title in /cart.js resta intero: questa e solo presentazione. */
  function splitName(full) {
    var fn = window.ZAGARA && window.ZAGARA.splitTitle;
    if (typeof fn === 'function') return fn(full);
    return { name: String(full || '').trim(), sub: '' };
  }
  function itemsStr(n) {
    var tpl = n === 1 ? (I18N.itemOne || '1 item') : (I18N.itemsOther || '9999 items');
    return tpl.replace(n === 1 ? '1' : '9999', n);
  }

  var CHANGE_EVENT = 'zagara:cart:change';

  // Locale-aware endpoints: routes.root is '/it/' on localized storefronts
  var ROUTES = window.routes || {};
  var ROOT = ROUTES.root || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  // ── State ─────────────────────────────────────────────────
  var cart = null;
  var drawerOpen = false;
  var dropdownOpen = false;
  var hoverTimer = null;

  // ── Helpers ───────────────────────────────────────────────
  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // CDN URLs usually carry ?v=…, but don't assume a query string exists.
  function withWidth(u, w) {
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // La testata del telefono (giro finale, tappa 2, voce t2-soglia): UNA media query per tutto il JS,
  // window.ZAGARA.testataTelefono (luxury.js, primo blocco; 1151.98 px, come il CSS della testata). Sotto la
  // soglia l'icona del carrello apre /cart, sopra la tendina ancorata all'icona. Prima qui c'era innerWidth <= 767:
  // fra 768 e 1151, con la testata del telefono, la tendina si sarebbe aperta dall'icona del telefono. Senza
  // luxury.js decide il CSS: si vede la testata del telefono.
  function testataTelefono() {
    var mq = window.ZAGARA && window.ZAGARA.testataTelefono;
    if (mq) return mq.matches;
    var m = document.querySelector('.header-inner--m');
    return !!(m && getComputedStyle(m).display !== 'none');
  }

  // The header renders its controls once per breakpoint branch (desktop and
  // mobile markup): writes go to every instance, reads use the visible one.
  function cartToggles() { return document.querySelectorAll('[data-role="cart-toggle"]'); }
  function visibleCartToggle() {
    var list = cartToggles();
    for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null) return list[i]; }
    return list[0] || null;
  }

  function formatMoney(cents) {
    // Shared formatter (luxury.js) handles all Shopify amount placeholders.
    if (window.zagaraFormatMoney) return window.zagaraFormatMoney(cents);
    var fmt = window.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (/comma_separator/.test(fmt)) amount = amount.replace('.', ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
  }

  // La soglia della spedizione gratuita si scrive come nella striscia, nel piede e nella pagina del carrello
  // (money_without_trailing_zeros: «$100», «100 €»); un importo coi centesimi veri resta intatto («$99.50»). Correzioni
  // del revisore di t2-spedizione, D1: il cassetto diceva «$100.00».
  function formatThreshold(cents) {
    return formatMoney(cents).replace(/[.,]00(?!\d)/, '');
  }

  // Turn a non-OK cart API response into a rejected promise carrying the
  // shopper-facing text Shopify returns ({status, message, description}).
  function httpError(r) {
    return r.json().catch(function () { return {}; }).then(function (body) {
      var err = new Error('HTTP ' + r.status);
      err.userMessage = body.description || body.message || '';
      throw err;
    });
  }

  // ── Cart API ──────────────────────────────────────────────
  // Find gift groups (_gift_id) that have ONLY component lines (container/letter)
  // and no product line left — i.e. orphaned leftovers — and return line-key
  // updates to remove them. Returns null if there are none.
  function orphanGiftUpdates(data) {
    if (!data || !data.items) return null;
    var groups = {};
    for (var i = 0; i < data.items.length; i++) {
      var it = data.items[i];
      var g = it.properties && it.properties['_gift_id'];
      if (!g) continue;
      if (!groups[g]) groups[g] = { hasProduct: false, keys: [] };
      groups[g].keys.push(it.key);
      if (!(it.properties && it.properties['_gift_component'])) groups[g].hasProduct = true;
    }
    var updates = null;
    for (var g2 in groups) {
      if (Object.prototype.hasOwnProperty.call(groups, g2) && !groups[g2].hasProduct) {
        updates = updates || {};
        for (var k = 0; k < groups[g2].keys.length; k++) { updates[groups[g2].keys[k]] = 0; }
      }
    }
    return updates;
  }

  // Le foto del carrello in UNA forma (foglio «Carrello — secondo giro», punto 1). /cart.js, change.js, update.js e clear.js
  // danno featured_image.url su «https://cdn.shopify.com/s/files/1/…/files/…», {{ cart | json }} (sezione e pagina) su
  // «//<negozio>/cdn/shop/files/…»: lo stesso file da due indirizzi. Ogni carrello che entra passa di qui e prende la forma del
  // negozio: le foto vengono dallo stesso dominio del sito e in cache ne sta una copia sola, e i carrelli delle diverse fonti
  // sono confrontabili campo per campo.
  function fotoDelNegozio(u) {
    if (typeof u !== 'string') return u;
    var m = u.match(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/((?:files|products)\/.*)$/) ||
            u.match(/^(?:https?:)?\/\/[^\/]+\/cdn\/shop\/((?:files|products)\/.*)$/);
    return m ? '//' + location.host + '/cdn/shop/' + m[1] : u;
  }
  function normalizzaFoto(c) {
    if (c && c.items) c.items.forEach(function (it) {
      if (it && it.featured_image && it.featured_image.url) it.featured_image.url = fotoDelNegozio(it.featured_image.url);
    });
    return c;
  }

  // Il carrello che arriva dal server, da /cart.js, dalla risposta di add.js (sezione zg-cart-json), da clear.js o dalla
  // pagina (#zg-cart-json): pulizia dei regali orfani, stato, evento. Prima stava dentro fetchCart; ora la usano tutte le
  // strade, cosi' la pulizia vale per ogni carrello letto (foglio «Due lavori in sequenza», parte B, punti 1, 6 e 7).
  // online-giro-01 (03/11/2026; la stessa logica di carrello-veloce-01 §1 su ZG-37, e2e6407): il giro fra le schede. Prima ogni carrello
  // letto mandava CHANGE_EVENT, l'evento scriveva localStorage.zagara_cart_ts e le altre schede, sull'evento storage, rileggevano
  // /cart.js: con due schede aperte si rimandavano la palla per sempre. Ora: CHANGE_EVENT solo se la firma() cambia; zagara_cart_ts
  // lo scrive solo avvisaSchede(), chiamata da chi ha fatto un'azione del cliente (annuncia = true); una lettura nata da storage non
  // avvisa mai.
  function avvisaSchede() {
    try { localStorage.setItem('zagara_cart_ts', String(Date.now())); } catch (err) {}
  }
  function accogli(data, cb, _cleaned, annuncia) {
    normalizzaFoto(data);
    if (cart && firma(data) === firma(cart)) { cart = data; if (cb) cb(data); return; }   // stesso carrello: niente evento
    var updates = _cleaned ? null : orphanGiftUpdates(data);
    if (updates) {
      // self-heal: strip orphaned container/letter lines, then re-read
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (clean) {
          cart = normalizzaFoto(clean);
          document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: clean }));
          if (annuncia) avvisaSchede();
          if (cb) cb(clean);
        })
        .catch(function () {
          cart = data;
          document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: data }));
          if (annuncia) avvisaSchede();
          if (cb) cb(data);
        });
      return;
    }
    cart = data;
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: data }));
    if (annuncia) avvisaSchede();
    if (cb) cb(data);
  }

  // annuncia: true solo dopo un'azione del cliente in questa scheda (vedi avvisaSchede)
  function fetchCart(cb, _cleaned, annuncia) {
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { accogli(data, cb, _cleaned, annuncia); })
      .catch(function (err) { console.error('[zagara:cart] cart refresh failed', err); });
  }

  // Rilettura di controllo (al primo momento libero dopo il carrello della pagina, e al ritorno dalla cache avanti/indietro):
  // se il server dice lo stesso carrello, niente evento e niente disegno. «Lo stesso» sui campi che questo file usa: il JSON di
  // Liquid e quello di /cart.js non sono mai identici per intero (token, discount_codes e altri campi che qui non servono), e un
  // evento in piu' a ogni pagina avviserebbe due volte le altre schede (zagara_cart_ts).
  function firma(c) {
    if (!c || !c.items) return '';
    return JSON.stringify([c.item_count, c.items_subtotal_price, c.total_price, c.currency, c.cart_level_discount_applications,
      c.items.map(function (i) {
        return [i.key, i.quantity, i.price, i.line_price, i.final_line_price, i.product_title, i.variant_title, i.vendor,
          i.featured_image && i.featured_image.url, i.properties, i.product_type, i.product_id];
      })]);
  }
  function rinfresca() {
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        normalizzaFoto(data);
        if (cart && firma(data) === firma(cart)) { cart = data; return; }   // stesso carrello: si tiene quello del server, in silenzio
        accogli(data);
      })
      .catch(function (err) { console.error('[zagara:cart] cart refresh failed', err); });
  }

  // Il carrello nella risposta di add.js: la sezione zg-cart-json stampa {{ cart | json }} (sections/zg-cart-json.liquid),
  // cosi' l'aggiunta e' UN giro col server invece di add.js + /cart.js. Shopify la consegna avvolta nel suo <div>.
  var SEZIONE_CARRELLO = 'zg-cart-json';
  function cartDaSezioni(resp) {
    var h = resp && resp.sections && resp.sections[SEZIONE_CARRELLO];
    if (typeof h !== 'string') return null;
    var a = h.indexOf('{'), b = h.lastIndexOf('}');
    if (a < 0 || b < a) return null;
    try { var c = JSON.parse(h.slice(a, b + 1)); return c && c.items ? c : null; } catch (e) { return null; }
  }

  // Adds are serialized through a promise chain: a click that lands while
  // another add is in flight queues up instead of being silently dropped,
  // so every caller's callback (success or failure) always fires.
  var addQueue = Promise.resolve();

  function apiAdd(variantId, qty, cb, onError) {
    addQueue = addQueue.then(function () {
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1, sections: SEZIONE_CARRELLO })
      })
        .then(function (r) {
          if (!r.ok) return httpError(r);
          return r.json();
        })
        .then(function (item) {
          var c = cartDaSezioni(item);
          if (item) delete item.sections;   // chi riceve item lo riceve come prima
          if (c) accogli(c, function () { if (cb) cb(item); }, false, true);
          else fetchCart(function () { if (cb) cb(item); }, false, true);
        })
        .catch(function (err) { if (onError) onError(err); });
    });
  }

  // Transient, assertive error line for failed cart mutations (quantity past
  // stock, network hiccup). Shown inside the dropdown when open, otherwise at
  // the top of the cart-page items column.
  function showCartError(msg) {
    msg = msg || I18N.cartError || 'Something went wrong — please try again.';
    var host = dropdownOpen ? document.querySelector('#luxCartDropdown .lcd-dd__body') : null;
    if (!host) host = document.getElementById('lxCartItems');
    if (!host) return;
    var el = host.querySelector('.lcd-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'lcd-error';
      el.setAttribute('role', 'alert');
      host.insertBefore(el, host.firstChild);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(showCartError._t);
    showCartError._t = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 250);
    }, 4000);
  }

  // Rapid +/- clicks fire overlapping change requests; responses can resolve
  // out of order, so only the most recently issued change may write state.
  var changeSeq = 0;

  function apiChange(lineKey, qty, cb) {
    var seq = ++changeSeq;
    // Gift grouping: removing one line of a built gift removes the WHOLE gift
    // (its product[s] + container + letter share a hidden _gift_id), so no
    // orphaned container/letter line is ever left behind in the cart.
    if (qty === 0 && cart && cart.items) {
      var gid = '';
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.key === lineKey && it.properties && it.properties['_gift_id']) { gid = it.properties['_gift_id']; break; }
      }
      if (gid) {
        var updates = {};
        for (var j = 0; j < cart.items.length; j++) {
          if (cart.items[j].properties && cart.items[j].properties['_gift_id'] === gid) { updates[cart.items[j].key] = 0; }
        }
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) {
            if (!r.ok) return httpError(r);
            return r.json();
          })
          .then(function (data) {
            if (seq !== changeSeq) { if (cb) cb(null); return; } // superseded: signal so callers settle
            cart = normalizzaFoto(data);
            document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: data }));
            avvisaSchede();
            if (cb) cb(data);
          })
          .catch(function (err) {
            if (seq !== changeSeq) { if (cb) cb(null); return; }
            recoverFromChangeError(err, cb);
          });
        return;
      }
    }
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return httpError(r);
        return r.json();
      })
      .then(function (data) {
        if (seq !== changeSeq) { if (cb) cb(null); return; } // superseded: signal so callers settle
        cart = normalizzaFoto(data);
        document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: data }));
        avvisaSchede();
        if (cb) cb(data);
      })
      .catch(function (err) {
        if (seq !== changeSeq) { if (cb) cb(null); return; }
        recoverFromChangeError(err, cb);
      });
  }

  // A change failed (e.g. 422 past available stock): never let the error body
  // become the cart. Re-read server truth so optimistic UI reverts, then
  // surface Shopify's description to the shopper.
  function recoverFromChangeError(err, cb) {
    fetchCart(function (data) {
      if (cb) cb(data);
      showCartError(err && err.userMessage);
    });
  }

  // +/− nel cassetto, nella tendina e nella pagina /cart (parte B, punto 4). Il numero cambia subito, come prima; al server va
  // una richiesta per riga alla volta, con l'ultima quantita' voluta (non le intermedie). Riga ferma: il tocco parte subito,
  // cosi' un tocco solo non aspetta. Tocchi ravvicinati: si raccolgono e partono in UNA richiesta dopo PAUSA_QTA ms senza
  // tocchi, e mai mentre un'altra richiesta della stessa riga e' in volo (se la pausa e' passata, partono al suo ritorno).
  // Finche' una riga ha una quantita' voluta, i disegni mostrano quella e non la quantita' del server.
  var PAUSA_QTA = 300;
  var voluti = {};      // chiave della riga -> { q: quantita' voluta, t: timer della pausa, inVolo }
  var rimozioni = {};   // chiave -> true mentre la richiesta di un «Remove» del cassetto o della tendina e' in volo

  function quantitaVoluta(key) { var v = voluti[key]; return v ? v.q : null; }

  function vuoiQuantita(key, q) {
    var v = voluti[key];
    if (!v) { voluti[key] = { q: q, t: null, inVolo: false }; mandaQuantita(key); return; }
    v.q = q;
    clearTimeout(v.t);
    v.t = setTimeout(function () { v.t = null; mandaQuantita(key); }, q === 0 ? 0 : PAUSA_QTA);
  }

  function annullaQuantita(key) {
    var v = voluti[key];
    if (v) { clearTimeout(v.t); delete voluti[key]; }
  }

  function mandaQuantita(key) {
    var v = voluti[key];
    if (!v || v.inVolo) return;   // in volo: riparte al ritorno
    var q = v.q;
    v.inVolo = true;
    apiChange(key, q, function () {
      if (voluti[key] !== v) return;   // la riga e' stata tolta nel frattempo
      v.inVolo = false;
      if (v.t) return;                 // la pausa non e' finita: la manda il timer
      if (v.q !== q) { mandaQuantita(key); return; }
      delete voluti[key];
      mostraQuantitaVera(key);         // es. 422: il server ha tenuto un'altra quantita'
    });
  }

  // Senza disegnare: la quantita' del server su ogni controllo di questa riga (pillole e campo della pagina /cart).
  function mostraQuantitaVera(key) {
    var item = null;
    if (cart && cart.items) for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { item = cart.items[i]; break; } }
    if (!item) return;
    document.querySelectorAll('.lcd-qty-pill').forEach(function (pill) {
      if (pill.dataset.qtyKey !== key || parseInt(pill.dataset.qtyVal, 10) === item.quantity) return;
      pill.dataset.qtyVal = item.quantity;
      var v = pill.querySelector('.lcd-qty-pill__val');
      if (v) v.textContent = item.quantity;
    });
    document.querySelectorAll('[data-cp-key]').forEach(function (row) {
      if (row.dataset.cpKey !== key || row.dataset.cpRemoving || parseInt(row.dataset.cpQty, 10) === item.quantity) return;
      row.dataset.cpQty = item.quantity;
      var v = row.querySelector('[data-cp-qty-val]');
      if (v) setQtyEl(v, item.quantity);
    });
  }

  // ── Badge ─────────────────────────────────────────────────
  function updateBadge() {
    if (!cart) return;
    var count = cart.item_count;
    document.querySelectorAll('[data-role="cart-badge"]').forEach(function (badge) {
      var prev = parseInt(badge.textContent, 10) || 0;
      badge.textContent = count > 99 ? '99+' : String(count);
      if (count === 0) {
        badge.classList.remove('cart-badge--visible');
      } else {
        badge.classList.add('cart-badge--visible');
        if (count !== prev) {
          badge.classList.remove('cart-badge--pulse');
          void badge.offsetWidth;
          badge.classList.add('cart-badge--pulse');
          badge.addEventListener('animationend', function () {
            badge.classList.remove('cart-badge--pulse');
          }, { once: true });
        }
      }
    });
    cartToggles().forEach(function (toggle) {
      toggle.setAttribute('aria-label',
        (I18N.bagAria || 'Shopping bag') + ', ' + itemsStr(count));
    });
  }

  // ── Drawer ────────────────────────────────────────────────
  function openDrawer(productData) {
    var drawer  = document.getElementById('luxCartDrawer');
    var overlay = document.getElementById('luxCartOverlay');
    if (!drawer) return;
    var wasOpen = drawerOpen;
    // Opening must never depend on drawing: a cart that opens and shows
    // little is a cart; a cart that will not open is a closed shop.
    try { renderCartDrawer(); }
    catch (err) { console.error('[zagara:cart] drawer render failed on open', err); }
    drawer.setAttribute('aria-hidden', 'false');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawerOpen = true; /* raised only once the panel is truly on screen */
    if (window.zgFocusTrap) zgFocusTrap.on(drawer);
    if (overlay) overlay.classList.add('is-active');
    // Refcounted lock (wasOpen guard keeps on/off balanced on re-opens)
    if (!wasOpen) {
      if (window.zgScrollLock) zgScrollLock.on();
      else document.body.style.overflow = 'hidden';
    }
    var closeBtn = drawer.querySelector('[data-lcd-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 420);
  }

  function closeDrawer() {
    // Look the element up BEFORE off(): passing undefined would release
    // whichever trap is active (e.g. the search overlay's).
    var drawer  = document.getElementById('luxCartDrawer');
    if (window.zgFocusTrap) zgFocusTrap.off(drawer);
    if (!drawerOpen) return;
    drawerOpen = false;
    var overlay = document.getElementById('luxCartOverlay');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.classList.add('is-closing');
      setTimeout(function () {
        if (drawer) { drawer.classList.remove('is-closing'); drawer.setAttribute('aria-hidden', 'true'); }
      }, 380);
    }
    if (overlay) overlay.classList.remove('is-active');
    if (window.zgScrollLock) zgScrollLock.off();
    else document.body.style.overflow = '';
    var toggle = visibleCartToggle();
    if (toggle) setTimeout(function () { toggle.focus(); }, 100);
  }

  // ── Righe al loro posto (parte B, punto 5) ───────────────────
  // Prima ogni cambio riscriveva le righe con innerHTML: foto ridisegnate e fuoco perso sul bottone premuto. Ora le righe si
  // cercano per chiave (data-item-key): quelle che restano si aggiornano (quantita', prezzo), le nuove si creano dallo stesso
  // modello di prima, quelle sparite si tolgono. Una riga col «Remove» appena premuto (data-lcd-uscita) finisce la sua
  // dissolvenza di 220 ms prima di sparire. Come faceva innerHTML, a ogni disegno se ne vanno il vuoto e i messaggi d'errore
  // del disegno prima.
  var USCITA_MS = 230;
  function restoUscita(n) {
    return n.dataset && n.dataset.lcdUscita ? Math.max(0, +n.dataset.lcdUscita + USCITA_MS - performance.now()) : 0;
  }
  function togliNodo(n) {
    if (n.dataset.lcdVia) return;
    n.dataset.lcdVia = '1';
    var resta = restoUscita(n);
    if (resta > 0) setTimeout(function () { n.remove(); }, resta); else n.remove();
  }
  function ripristinaRiga(n) {
    if (!n.dataset.lcdUscita) return;
    delete n.dataset.lcdUscita;
    n.style.transition = ''; n.style.opacity = ''; n.style.transform = '';
  }
  function allineaRighe(host, sel, items, crea, aggiorna, nome) {
    var esistenti = {};
    Array.prototype.slice.call(host.children).forEach(function (n) {
      if (n.matches(sel) && n.dataset.itemKey && !n.dataset.lcdVia) esistenti[n.dataset.itemKey] = n;
      else if (!n.matches(sel)) n.remove();   // vuoto, .lcd-error, .lcd-render-error del disegno prima
    });
    var presenti = {}, prima = null;
    items.forEach(function (item) {
      var n = esistenti[item.key];
      try {
        if (n) {
          aggiorna(n, item);
          if (!rimozioni[item.key]) ripristinaRiga(n);
        } else {
          var t = document.createElement('template');
          t.innerHTML = crea(item);
          n = t.content.firstElementChild;
          if (!n) return;
        }
      } catch (err) {
        console.error('[zagara:cart] ' + nome + ' line failed for "' + (item && item.product_title) + '"', err);
        return;
      }
      presenti[item.key] = true;
      var dove = prima ? prima.nextSibling : host.firstChild;
      if (n !== dove) host.insertBefore(n, dove);
      prima = n;
    });
    Object.keys(esistenti).forEach(function (k) { if (!presenti[k]) togliNodo(esistenti[k]); });
  }
  // Carrello vuoto: il blocco del vuoto arriva quando l'ultima riga in uscita ha finito la dissolvenza.
  function mettiVuoto(host, sel, html) {
    var resta = 0;
    Array.prototype.forEach.call(host.querySelectorAll(sel), function (n) { resta = Math.max(resta, restoUscita(n)); });
    function metti() { if (cart && cart.item_count) return; host.innerHTML = html; }
    if (resta > 0) setTimeout(metti, resta); else metti();
  }
  function aggiornaPillola(n, item) {
    var pill = n.querySelector('.lcd-qty-pill');
    if (!pill) return;
    var q = quantitaVoluta(item.key);
    if (q == null) q = item.quantity;
    if (parseInt(pill.dataset.qtyVal, 10) !== q) pill.dataset.qtyVal = q;
    var v = pill.querySelector('.lcd-qty-pill__val');
    if (v && v.textContent !== String(q)) v.textContent = q;
  }
  function aggiornaPrezzo(el, html) {
    if (!el || el._zgPrezzo === html) return;
    if (el.innerHTML !== html) el.innerHTML = html;
    el._zgPrezzo = html;
  }
  function quantitaMostrata(item) {
    var q = quantitaVoluta(item.key);
    return q == null ? item.quantity : q;
  }

  // Full side-cart rendering: goal block, line cards, summary, dynamic CTA.
  // Everything derives from the shared `cart` state and re-renders on
  // CHANGE_EVENT, so quantity edits update goal/progress/totals live.
  function minOrderTarget() {
    var cents = parseInt(window.ZAGARA && window.ZAGARA.minOrderCents, 10);
    return cents > 0 ? cents : 0;
  }

  function freeDeliveryTarget() {
    var cents = parseInt(window.ZAGARA && window.ZAGARA.freeShippingThresholdCents, 10);
    return cents > 0 ? cents : 0;
  }

  // Ready-made gift boxes are the entry price to gifting: one in the bag lifts
  // the minimum for the whole order. Gift builder parts never do — they are
  // helpers, not a gift anyone chose.
  function minExempt() {
    var types = (window.ZAGARA && window.ZAGARA.minOrderExemptTypes) || [];
    if (!types.length || !cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return types.indexOf(item.product_type) !== -1;
    });
  }

  // One rule, three surfaces: drawer, dropdown and /cart must never disagree
  // about whether this cart can be paid for. Returns the cents still missing,
  // or 0 when checkout is allowed.
  // aria-disabled, never the disabled attribute: the button stays focusable
  // and keeps announcing why, and the submit is stopped instead.
  function setBlocked(el, noteEl, missing, noteId) {
    if (!el) return;
    if (missing) {
      el.setAttribute('aria-disabled', 'true');
      if (noteId) el.setAttribute('aria-describedby', noteId);
    } else {
      el.removeAttribute('aria-disabled');
      el.removeAttribute('aria-describedby');
    }
    if (noteEl) noteEl.hidden = !missing;
  }

  function checkoutBlocked() {
    var min = minOrderTarget();
    if (!min || minExempt()) return 0;
    var missing = min - (cart ? cart.items_subtotal_price : 0);
    return missing > 0 ? missing : 0;
  }

  function renderCartDrawer() {
    // A half-drawn drawer must say so — never show $0.00 over real goods.
    try { renderCartDrawerInner(); }
    catch (err) {
      console.error('[zagara:cart] drawer render failed', err);
      var lines = document.getElementById('lcdLines');
      if (lines && !lines.querySelector('.lcd-render-error')) {
        var p = document.createElement('p');
        p.className = 'lcd-render-error';
        p.setAttribute('role', 'alert');
        p.textContent = I18N.cartError || 'Something went wrong — please try again.';
        lines.prepend(p);
      }
    }
  }

  function preorderMeta(item, cls) {
    // Pre-order (SMART Preorder, 01/11/2026): "Pre-order - Ships from <data>" sulla riga del carrello se l'articolo ha il piano
    // di vendita dell'app. "Ships from" e' il nome della proprieta' impostato nella campagna (Settings > Add a line to pre-order items).
    var alloc = item.selling_plan_allocation;
    if (!alloc || !alloc.selling_plan) return '';
    var txt = alloc.selling_plan.name || 'Pre-order';
    var ships = item.properties && item.properties['Ships from'];
    if (ships) txt += ' \u00b7 Ships from ' + ships;
    return '<p class="' + cls + ' ' + cls + '--preorder">' + esc(txt) + '</p>';
  }

  function rigaCassetto(item) {
    var imgSrc = item.featured_image && item.featured_image.url ? esc(withWidth(item.featured_image.url, 180)) : '';
    var img = imgSrc
      ? '<img src="' + imgSrc + '" alt="" loading="eager" fetchpriority="high" width="90" height="90">'
      : '<span class="lcd-line__ph"></span>';
    var meta = item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title
      : (item.vendor || '');
    var nm = splitName(item.product_title);
    var giftMeta = item.properties && item.properties['_gift_id']
      ? '<p class="lcd-line__meta lcd-line__meta--gift">' + esc(I18N.partOfGift || 'Part of your gift box') + '</p>'
      : '';
    return (
      '<div class="lcd-line" data-item-key="' + esc(item.key) + '">' +
        '<div class="lcd-line__media">' + img + '</div>' +
        '<div class="lcd-line__info">' +
          '<p class="lcd-line__name">' + esc(nm.name) + '</p>' +
          (nm.sub ? '<p class="lcd-line__meta">' + esc(nm.sub) + '</p>' : '') +
          (meta ? '<p class="lcd-line__meta">' + esc(meta) + '</p>' : '') +
          giftMeta + preorderMeta(item, 'lcd-line__meta') +
          '<p class="lcd-line__price">' + formatMoney(item.price) + '</p>' +
        '</div>' +
        '<div class="lcd-line__side">' +
          '<button class="lcd-line__remove" data-remove-key="' + esc(item.key) + '" aria-label="' + esc(I18N.remove || 'Remove') + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/><path d="M10 11v6M14 11v6"/></svg>' +
          '</button>' +
          '<div class="lcd-qty-pill" data-qty-key="' + esc(item.key) + '" data-qty-val="' + quantitaMostrata(item) + '">' +
            '<button class="lcd-qty-pill__btn" data-qty-dec aria-label="' + esc(I18N.qtyDecrease || 'Decrease quantity') + '">−</button>' +
            '<span class="lcd-qty-pill__val">' + quantitaMostrata(item) + '</span>' +
            '<button class="lcd-qty-pill__btn" data-qty-inc aria-label="' + esc(I18N.qtyIncrease || 'Increase quantity') + '">+</button>' +
          '</div>' +
        '</div>' +
      '</div>');
  }

  function renderCartDrawerInner() {
    var lines = document.getElementById('lcdLines');
    if (!lines) return;
    var count = cart ? cart.item_count : 0;
    var min = minOrderTarget();

    // Goal block + value progress (minimum order VALUE, not item count)
    var goal = document.getElementById('lcdGoal');
    // Due cifre, due regole (giro finale, tappa 3, voce t3-soglia-sconti; foglio 10 §2.12). La spedizione gratuita la
    // decide Shopify sul totale DOPO gli sconti: il titolo della soglia, la barra sopra il minimo e il «Free» del riepilogo
    // leggono cart.total_price, cioe' il «Total» scritto sotto (anche gli sconti sull'ordine, cart_level_discount_applications;
    // quelli sulle righe sono gia' anche in items_subtotal_price). Il minimo resta su items_subtotal_price
    // (checkoutBlocked, la stessa cifra nelle tre superfici): sotto il minimo il titolo e la barra contano sul subtotale
    // (correzioni del revisore, barCents piu' sotto). Prima tutto su items_subtotal_price: con il 10% sull'ordine un subtotale di $105
    // diceva «Free standard delivery from $100» sopra un totale di $94.50, che per Shopify e' sotto la soglia (banco
    // tappa3/banco-t3-soglia-sconti, caso d10500).
    var totalCents = cart ? cart.total_price : 0;
    if (goal) {
      // The block tells the whole scale, not just the wall: what is missing to
      // the minimum, and what is missing to free delivery. The bar carries a
      // notch for each, so the second one is visible before it is reached.
      var free = freeDeliveryTarget();
      var blocked = checkoutBlocked();
      var span = Math.max(min, free);
      // An empty bag has no goal to miss: the block would otherwise read
      // "Add $60.00 more" over nothing at all.
      if (span && count > 0) {
        var title, rule;
        if (blocked) {
          title = (I18N.minTitleMissing || 'Add %AMOUNT% more').replace('%AMOUNT%', formatMoney(blocked));
          rule = free
            ? (I18N.minRuleWithDelivery || 'Minimum order of %MIN% · Free delivery from %THRESHOLD%')
                .replace('%MIN%', formatMoney(min)).replace('%THRESHOLD%', formatThreshold(free))
            : (I18N.minRule || 'Minimum order of %AMOUNT%').replace('%AMOUNT%', formatMoney(min));
        } else if (free && totalCents < free) {
          title = (I18N.freeDeliveryMissing || 'Add %AMOUNT% more for free standard delivery')
                    .replace('%AMOUNT%', formatMoney(free - totalCents));
          rule = '';
        } else if (free) {
          title = (I18N.freeDeliveryReached || 'Free standard delivery from %THRESHOLD%')
                    .replace('%THRESHOLD%', formatThreshold(free));
          rule = '';
        } else {
          title = (I18N.minTitleReached || 'Minimum order reached');
          rule = '';
        }
        // Revisione di t3-soglia-sconti (proposta): la barra misura la cifra della regola che il titolo racconta. Sotto il
        // minimo il titolo conta sul subtotale (checkoutBlocked), quindi anche la barra; sopra il minimo conta la soglia della
        // spedizione, sul totale dopo gli sconti. Con lo sconto sull'ordine, prima: «Add $5.00 more» sopra una barra a $49.50
        // con la tacca dei $60 a $10.50.
        var barCents = blocked ? (cart ? cart.items_subtotal_price : 0) : totalCents;
        var pct = Math.min(1, barCents / span);
        var marks = '';
        // Tappa 1b (b-bassi-carrello, correzioni del revisore): la tacca si misura dal lato d'inizio della pista
        // (inset-inline-start), come il riempimento, che in arabo cresce da destra (lux-cart.css, [dir="rtl"]
        // .lcd-goal__fill). Con `left` la tacca del minimo stava al 60% da sinistra, dentro la parte gia' riempita,
        // e la barra diceva «minimo superato» sotto il titolo «Add $16.60 more».
        [min, free].forEach(function (mark) {
          if (!mark || mark >= span) return;
          // Minimo passato (sul subtotale, o una gift box) e totale scontato sotto la tacca: la tacca direbbe «non ancora»
          // sotto un pagamento libero. Non si disegna.
          if (mark === min && !blocked && barCents < min) return;
          marks += '<span class="lcd-goal__mark" style="inset-inline-start:' + ((mark / span) * 100).toFixed(2) + '%"></span>';
        });
        goal.hidden = false;
        goal.innerHTML =
          '<p class="lcd-goal__title">' + esc(title) + '</p>' +
          (rule ? '<p class="lcd-goal__rule">' + esc(rule) + '</p>' : '') +
          '<div class="lcd-goal__track" role="img" aria-label="' + esc(formatMoney(Math.min(barCents, span)) + ' / ' + formatMoney(span)) + '">' +
            '<span class="lcd-goal__fill' + (blocked ? '' : ' is-done') + '" style="transform:scaleX(' + pct.toFixed(3) + ')"></span>' +
            marks +
          '</div>';
      } else {
        goal.hidden = true;
        goal.innerHTML = '';
      }
    }

    // Line cards: al loro posto per chiave (parte B, punto 5): quantita' e prezzo si aggiornano, le righe nuove si aggiungono,
    // quelle sparite si tolgono. Le foto non si ridisegnano e il fuoco resta sul bottone premuto.
    if (!cart || count === 0) {
      mettiVuoto(lines, '.lcd-line',
        '<div class="lcd-empty">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
            '<p class="lcd-empty__title">' + esc(I18N.bagEmptyTitle || 'Your bag is empty') + '</p>' +
            '<p class="lcd-empty__sub">' + esc(I18N.bagEmptySub || 'Discover our Sicilian selections to start filling it up.') + '</p>' +
          '</div>');
    } else {
      allineaRighe(lines, '.lcd-line', cart.items, rigaCassetto, function (n, item) {
        aggiornaPillola(n, item);
        aggiornaPrezzo(n.querySelector('.lcd-line__price'), formatMoney(item.price));
      }, 'drawer');
    }

    // Summary
    var subEl = document.getElementById('lcdSubtotal');
    var shipEl = document.getElementById('lcdShipping');
    var totEl = document.getElementById('lcdTotal');
    if (subEl && cart) animateValue(subEl, formatMoney(cart.items_subtotal_price));
    if (totEl && cart) animateValue(totEl, formatMoney(cart.total_price));
    if (shipEl && cart) {
      // «Free» sulla stessa cifra della soglia qui sopra, il totale dopo gli sconti (voce t3-soglia-sconti).
      var threshold = parseInt(window.ZAGARA && window.ZAGARA.freeShippingThresholdCents, 10) || 0;
      shipEl.textContent = threshold && cart.total_price >= threshold
        ? (I18N.freeLabel || 'Free')
        : (I18N.shipAtCheckout || 'Calculated at checkout');
    }

    // The checkout never leaves the drawer. Below the minimum it stays in
    // place, reachable by keyboard and announced as unavailable, with the
    // reason beside it; the way back to the shop becomes a secondary link.
    var cta = document.getElementById('lcdCta');
    var note = document.getElementById('lcdBlocked');
    var alt = document.getElementById('lcdCtaAlt');
    if (cta) {
      var missingForCta = checkoutBlocked();
      cta.textContent = (I18N.checkout || 'Checkout') + ' \u2192';
      cta.setAttribute('href', (ROUTES.cart || '/cart') + '/checkout');
      delete cta.dataset.lcdGoshop;
      setBlocked(cta, note, missingForCta, 'lcdBlocked');
      cta.classList.toggle('lcd-cta--goal', !!missingForCta);
      if (alt) alt.hidden = !missingForCta;
    }
  }

  // aria-disabled has no behaviour of its own: the navigation is stopped here.
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[aria-disabled="true"]');
    if (!el) return;
    e.preventDefault();
    var noteId = el.getAttribute('aria-describedby');
    var note = noteId && document.getElementById(noteId);
    if (note) note.hidden = false;
  }, true);

  // Below-minimum CTA: close the drawer and return to the shop. When the
  // shopper is already browsing a collection, closing is enough.
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-lcd-goshop]');
    if (!cta) return;
    if (location.pathname.indexOf('/collections') !== -1) {
      e.preventDefault();
    }
    closeDrawer();
  });

  // ── Dropdown ──────────────────────────────────────────────
  function positionDropdown() {
    var toggle = visibleCartToggle();
    var dd     = document.getElementById('luxCartDropdown');
    if (!toggle || !dd) return;
    var rect = toggle.getBoundingClientRect();
    dd.style.top   = (rect.bottom + 10) + 'px';
    // Tappa 1b (b-bassi-carrello): in arabo l'icona del carrello sta a sinistra, e la tendina appesa al suo bordo
    // destro usciva dallo schermo (sul banco a 1512 da -314 a 86 px: se ne vedevano 86 su 400; a 768, 56).
    // Correzioni del revisore: il lato lo sceglie la DIREZIONE della pagina, non lo spazio libero (prima, in arabo
    // oltre i 2400 px circa la tendina tornava appesa al bordo destro dell'icona e si apriva verso il bordo dello
    // schermo). Da destra a sinistra: appesa al bordo sinistro dell'icona, si apre verso il centro, fra 16 px e
    // innerWidth - larghezza - 16. Da sinistra a destra: com'era, uguale al pixel. La gemella e' positionPanel in
    // lux-wishlist.js (il pannello dei preferiti, stesso difetto): si cambiano insieme.
    if (getComputedStyle(document.documentElement).direction === 'rtl') {
      dd.style.left  = Math.max(16, Math.min(rect.left, window.innerWidth - dd.offsetWidth - 16)) + 'px';
      dd.style.right = 'auto';
      dd.style.transformOrigin = 'top left';
    } else {
      dd.style.right = (window.innerWidth - rect.right) + 'px';
      dd.style.left  = 'auto';
      dd.style.transformOrigin = '';
    }
  }

  function openDropdown() {
    if (dropdownOpen) return;
    var dd = document.getElementById('luxCartDropdown');
    if (!dd) return;
    try { renderDropdown(); positionDropdown(); }
    catch (err) { console.error('[zagara:cart] dropdown render failed on open', err); }
    dd.setAttribute('aria-hidden', 'false');
    dd.classList.add('is-open');
    if (window.zgFocusTrap) zgFocusTrap.on(dd);
    dropdownOpen = true; /* raised only once the panel is truly on screen */
    /* Foglio 07 §2 (f07-rotella): anche la tendina blocca la pagina col blocco condiviso (ferma Lenis): la rotella sopra gli
       articoli scorre .lcd-dd__body (data-lenis-prevent), sopra il resto non muove niente. In pari con closeDropdown:
       qui si arriva solo da chiusa, li' si esce solo da aperta. */
    if (window.zgScrollLock) zgScrollLock.on();
    cartToggles().forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
  }

  function closeDropdown() {
    var dd = document.getElementById('luxCartDropdown');
    // off() must get the dropdown element — off(null) released any active trap.
    if (window.zgFocusTrap) zgFocusTrap.off(dd);
    if (!dropdownOpen) return;
    dropdownOpen = false;
    if (window.zgScrollLock) zgScrollLock.off();
    if (dd) {
      dd.classList.remove('is-open');
      dd.classList.add('is-closing');
      /* Giro finale, foglio 07, voce f07b-minicassetto, correzioni del revisore (P1, P2; c'erano gia' prima della voce).
         P2: riaperta prima dei 220 ms, la tendina restava aria-hidden="true" anche da aperta: il timer la nasconde solo se e'
             ancora chiusa.
         P1: col fuoco dentro (Esc, o il mouse che esce dalla borsa) la visibilita' che si spegne a fine chiusura (200 ms, 150 col
             moto ridotto: lux-cart.css) lo lasciava sul body. A 100 ms torna sulla borsa, come in closeDrawer; se un clic l'ha
             gia' portato altrove, o la tendina si e' riaperta, non si tocca. */
      setTimeout(function () {
        if (dd) { dd.classList.remove('is-closing'); if (!dropdownOpen) dd.setAttribute('aria-hidden', 'true'); }
      }, 220);
      setTimeout(function () {
        if (!dropdownOpen && dd.contains(document.activeElement)) { var t = visibleCartToggle(); if (t) t.focus(); }
      }, 100);
    }
    cartToggles().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  function renderDropdown() {
    // Same net as the drawer: a half-drawn dropdown must declare itself.
    try { renderDropdownInner(); }
    catch (err) {
      console.error('[zagara:cart] dropdown render failed', err);
      var dd = document.getElementById('luxCartDropdown');
      var body = dd && dd.querySelector('.lcd-dd__body');
      if (body && !body.querySelector('.lcd-render-error')) {
        var p = document.createElement('p');
        p.className = 'lcd-render-error';
        p.setAttribute('role', 'alert');
        p.textContent = I18N.cartError || 'Something went wrong — please try again.';
        body.prepend(p);
      }
    }
  }

  function rigaTendina(item) {
    var imgSrc = item.featured_image && item.featured_image.url ? esc(withWidth(item.featured_image.url, 120)) : '';
    var img = imgSrc
      ? '<img src="' + imgSrc + '" alt="" loading="eager" fetchpriority="high">'
      : '<div class="lcd-dd-item__ph"></div>';
    var meta = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : (item.vendor || '');
    // Built-gift lines (product + container + letter) share a hidden
    // _gift_id and are removed together — say so instead of showing them
    // as unrelated rows.
    var nmd = splitName(item.product_title);
    var giftMeta = item.properties && item.properties['_gift_id']
      ? '<p class="lcd-dd-item__meta lcd-dd-item__meta--gift">' + esc(I18N.partOfGift || 'Part of your gift box') + '</p>'
      : '';
    return (
      '<div class="lcd-dd-item" data-item-key="' + esc(item.key) + '">' +
        '<div class="lcd-dd-item__media">' + img + '</div>' +
        '<div class="lcd-dd-item__info">' +
          '<p class="lcd-dd-item__name">' + esc(nmd.name) + '</p>' +
          (nmd.sub ? '<p class="lcd-dd-item__meta">' + esc(nmd.sub) + '</p>' : '') +
          (meta ? '<p class="lcd-dd-item__meta">' + esc(meta) + '</p>' : '') +
          giftMeta + preorderMeta(item, 'lcd-dd-item__meta') +
          '<div class="lcd-dd-item__row">' +
            '<button class="lcd-dd-item__remove" data-remove-key="' + esc(item.key) + '">' + esc(I18N.remove || 'Remove') + '</button>' +
            '<div class="lcd-qty-pill" data-qty-key="' + esc(item.key) + '" data-qty-val="' + quantitaMostrata(item) + '">' +
              '<button class="lcd-qty-pill__btn" data-qty-dec aria-label="' + esc(I18N.qtyDecrease || 'Decrease quantity') + '">−</button>' +
              '<span class="lcd-qty-pill__val">' + quantitaMostrata(item) + '</span>' +
              '<button class="lcd-qty-pill__btn" data-qty-inc aria-label="' + esc(I18N.qtyIncrease || 'Increase quantity') + '">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<p class="lcd-dd-item__price">' + formatMoney(item.line_price) + '</p>' +
      '</div>');
  }

  function renderDropdownInner() {
    var dd = document.getElementById('luxCartDropdown');
    if (!dd) return;
    var body     = dd.querySelector('.lcd-dd__body');
    var footer   = dd.querySelector('.lcd-dd__footer');
    var countEl  = dd.querySelector('.lcd-dd__count');
    if (!body) return;

    if (!cart || cart.item_count === 0) {
      if (countEl) countEl.textContent = itemsStr(0);
      mettiVuoto(body, '.lcd-dd-item',
        '<div class="lcd-dd__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          '<p class="lcd-dd__empty-title">' + (I18N.bagEmptyTitle || 'Your bag is empty') + '</p>' +
          '<p class="lcd-dd__empty-sub">' + (I18N.bagEmptySub || 'Discover our Sicilian selections to start filling it up.') + '</p>' +
          '<a href="' + (ROUTES.all_products || '/collections/all') + '" class="btn btn--dark lcd-dd__explore" data-lcd-close>' + (I18N.explore || 'Explore selections') + '</a>' +
        '</div>');
      if (footer) footer.style.display = 'none';
      return;
    }

    if (countEl) countEl.textContent = itemsStr(cart.item_count);
    if (footer) footer.style.display = '';

    // Al loro posto per chiave, come nel cassetto (parte B, punto 5).
    allineaRighe(body, '.lcd-dd-item', cart.items, rigaTendina, function (n, item) {
      aggiornaPillola(n, item);
      aggiornaPrezzo(n.querySelector('.lcd-dd-item__price'), formatMoney(item.line_price));
    }, 'dropdown');
    var totalEl = dd.querySelector('.lcd-dd__total-val');
    if (totalEl) animateValue(totalEl, formatMoney(cart.total_price));

    // Third surface, same rule: the dropdown is rendered by Liquid once at
    // page load, so without this it would offer a checkout the drawer refuses.
    setBlocked(document.getElementById('lcdDdCheckout'),
               document.getElementById('lcdDdBlocked'),
               checkoutBlocked(), 'lcdDdBlocked');
  }

  function animateValue(el, newVal) {
    if (el.textContent === newVal) return;
    el.style.transition = 'opacity 150ms ease-in, transform 150ms ease-in';
    el.style.opacity = '0';
    el.style.transform = 'translateY(-4px)';
    setTimeout(function () {
      el.textContent = newVal;
      el.style.transition = 'opacity 200ms ease-out, transform 200ms ease-out';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 160);
  }

  // ── Fly-to-cart ───────────────────────────────────────────
  function flyToCart(sourceEl) {
    if (!sourceEl) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var toggle = visibleCartToggle();
    if (!toggle) return;
    var from = sourceEl.getBoundingClientRect();
    var to   = toggle.getBoundingClientRect();
    var ghost = document.createElement('div');
    var cx = from.left + from.width / 2 - 30;
    var cy = from.top  + from.height / 2 - 30;
    var dx = to.left + to.width / 2 - 30 - cx;
    var dy = to.top  + to.height / 2 - 30 - cy;
    ghost.style.cssText =
      'position:fixed;z-index:9999;pointer-events:none;border-radius:4px;overflow:hidden;' +
      'width:60px;height:60px;opacity:.75;background:rgba(201,169,97,.3);' +
      'left:' + cx + 'px;top:' + cy + 'px;' +
      'transition:transform 700ms cubic-bezier(0.5,-0.5,0.5,1.5),opacity 700ms ease;' +
      'will-change:transform,opacity;';
    var imgEl = sourceEl.closest('.col-card');
    var imgSrc = imgEl ? (imgEl.querySelector('img') || {}).src : '';
    if (imgSrc) ghost.innerHTML = '<img src="' + esc(imgSrc) + '" style="width:100%;height:100%;object-fit:cover;" alt="">';
    document.body.appendChild(ghost);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
        ghost.style.opacity   = '0';
        setTimeout(function () { ghost.remove(); }, 750);
      });
    });
  }

  // ── Product page intercept ────────────────────────────────
  function showFormError(form, msg) {
    var el = form.querySelector('.fp-form__error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'fp-form__error';
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(showFormError._t);
    showFormError._t = setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
  }

  function initProductPage() {
    var form = document.querySelector('form[data-add-to-cart]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.fp-add-btn');
      if (btn && btn.disabled) return;
      var idInput  = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput) return;
      var variantId = idInput.value;
      var qty       = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var productData = {
        name:      (document.querySelector('.fp-title') || {}).textContent || '',
        variant:   (function () { var sel = form.querySelector('select[name="id"]'); if (!sel) return ''; var o = sel.options[sel.selectedIndex]; return o ? o.text.split('—')[0].trim() : ''; })(),
        image:     (document.getElementById('mainProductImage') || {}).src || '',
        price:     (document.querySelector('.fp-price-current') || {}).textContent || '',
        producer:  (document.querySelector('.fp-vendor') || {}).textContent || ''
      };
      var orig = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.style.transition = 'transform 250ms ease';
        btn.style.transform  = 'scale(0.96)';
        setTimeout(function () { btn.style.transform = 'scale(1)'; }, 250);
        btn.textContent = I18N.adding || 'Adding…';
      }
      apiAdd(variantId, qty, function (item) {
        // Only report success once the server confirmed the add.
        if (btn) {
          btn.textContent = I18N.added || '✓ Added';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
        }
        productData.productId = item ? item.product_id : '';
        openDrawer(productData);
      }, function (err) {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        showFormError(form,
          (err && err.userMessage) || I18N.cartError || 'Something went wrong — please try again.');
      });
    });
  }

  // ── Cart page enhancements ────────────────────────────────
  function collapseCartRow(row) {
    row.dataset.cpRemoving = '1';
    row.style.transition = 'opacity 250ms ease-in, transform 250ms ease-in';
    row.style.opacity    = '0';
    row.style.transform  = 'translateX(-40px)';
    setTimeout(function () {
      row.style.transition = 'max-height 300ms ease-out, padding 300ms ease-out, margin 300ms ease-out';
      row.style.maxHeight  = '0';
      row.style.overflow   = 'hidden';
      row.style.padding    = '0';
      row.style.margin     = '0';
    }, 260);
  }

  // A collapsed row whose server-side removal failed comes back.
  function restoreCartRow(row) {
    delete row.dataset.cpRemoving;
    row.style.transition = '';
    row.style.maxHeight  = '';
    row.style.padding    = '';
    row.style.margin     = '';
    row.style.opacity    = '';
    row.style.transform  = '';
  }

  // Collapse the row, remove the line server-side, then settle the DOM from
  // the response: drop the node when the line is gone, restore it otherwise.
  // ── Empty the whole bag ────────────────────────────────────────────────
  // Sister of apiChange, deliberately additive: apiChange sits on the hot path
  // of every quantity change in the shop and is not touched here.
  // cart/clear.js empties what the SERVER holds, so a line added in another tab
  // a second ago goes too -- an updates{} built from our own cart.items could
  // miss it. Parte B, punto 6: la risposta di clear.js e' il carrello, campo per campo uguale a /cart.js (provato il
  // 20/10, carrello/confronta-json.mjs): passa da accogli(), come /cart.js, e il giro in piu' non c'e' piu'. Una risposta
  // senza righe leggibili torna alla rilettura di prima.
  function apiClear(cb) {
    var seq = ++changeSeq;            // an empty supersedes a quantity change in flight
    fetch(ROOT + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) return httpError(r);
        return r.json();
      })
      .then(function (data) {
        if (seq !== changeSeq) { if (cb) cb(null); return; }   // superseded: let the caller settle
        if (data && data.items) accogli(data, null, false, true); else fetchCart(null, false, true);   // stato + CHANGE_EVENT + le altre schede
        if (cb) cb(true);
      })
      .catch(function (err) {
        if (seq !== changeSeq) { if (cb) cb(null); return; }
        recoverFromChangeError(err, cb);
      });
  }

  // La richiesta parte al clic, con la chiusura della riga insieme (parte B, punto 3; prima dopo 260 ms). Tolta: la riga
  // sparisce finita la sua chiusura (260 + 300 ms); rifiutata: torna subito, come prima.
  function removeCartRow(row) {
    var key = row.dataset.cpKey, t0 = performance.now();
    annullaQuantita(key);
    collapseCartRow(row);
    apiChange(key, 0, function (data) {
      // data === null means a newer change superseded this removal: settle
      // from the latest known cart instead of leaving the row stuck collapsed.
      var truth = data || cart;
      var alive = !!(truth && truth.items && truth.items.some(function (i) { return i.key === key; }));
      if (alive) { restoreCartRow(row); updateCartPage(); return; }
      setTimeout(function () { row.remove(); if (!data) updateCartPage(); }, Math.max(0, t0 + 560 - performance.now()));
    });
  }

  // The cart-page quantity control is an <input>; drawers/dropdowns use spans.
  function setQtyEl(el, val) {
    if ('value' in el) el.value = val;
    else el.textContent = val;
  }

  // Cart-page total renders with the currency suffix (money_with_currency).
  function formatMoneyWC(cents) {
    var totalHost = document.getElementById('cpTotal');
    var fmt = (totalHost && totalHost.dataset.moneyWc) || window.moneyWithCurrencyFormat;
    if (fmt) {
      var amount = (cents / 100).toFixed(2);
      if (/comma_separator/.test(fmt)) amount = amount.replace('.', ',');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    }
    // The cart payload always carries the ISO currency code
    var base = formatMoney(cents);
    return cart && cart.currency ? base + ' ' + cart.currency : base;
  }

  /* 8d (02/09): il sommario e fisso sul telefono e alto quanto il suo
     contenuto (254 px con le CTA; di piu con l'avviso «sotto il minimo»); il
     padding-bottom della pagina era 11rem fissi e gli ultimi 78 px del
     contenuto finivano sotto il blocco. La misura vera va in una variabile
     CSS, al load, al resize e a ogni cambio del sommario; nel CSS c'e il
     ripiego 17rem + safe-area. */
  function syncSummaryHeight() {
    var page = document.getElementById('lxCartPage');
    var summary = document.getElementById('lxCartSummary');
    if (!page || !summary) return;
    var h = summary.offsetHeight;
    if (h > 0) page.style.setProperty('--cp-summary-h', h + 'px');
  }

  function initCartPage() {
    if (!document.getElementById('lxCartPage')) return;
    syncSummaryHeight();
    var summaryEl = document.getElementById('lxCartSummary');
    if (summaryEl && window.ResizeObserver) {
      new ResizeObserver(syncSummaryHeight).observe(summaryEl);
    }
    window.addEventListener('resize', syncSummaryHeight, { passive: true });

    // Typed quantities go through the same change flow as the +/- steppers
    document.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-cp-qty-val]');
      if (!input) return;
      var row = input.closest('[data-cp-key]');
      if (!row) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) { setQtyEl(input, row.dataset.cpQty || 1); return; }
      if (val === 0) { removeCartRow(row); return; }
      row.dataset.cpQty = val;
      vuoiQuantita(row.dataset.cpKey, val);
    });

    // Cart note: persists via the Cart API as it changes; the checkout submit
    // also posts it natively as part of the /cart form.
    var noteEl = document.getElementById('cartNote');
    if (noteEl) {
      noteEl.addEventListener('change', function () {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: noteEl.value })
        }).then(function (r) { if (r.ok) avvisaSchede(); }).catch(function () {});   // online-giro-01: la nota e' un'azione
      });
    }

    // Quantity controls
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cp-dec],[data-cp-inc]');
      if (!btn) return;
      var row  = btn.closest('[data-cp-key]');
      if (!row) return;
      var key  = row.dataset.cpKey;
      var cur  = parseInt(row.dataset.cpQty, 10) || 1;
      var next = btn.hasAttribute('data-cp-dec') ? cur - 1 : cur + 1;
      if (next <= 0) {
        // Quantity hit zero: the server removes the line, so treat it
        // exactly like Remove instead of leaving a ghost row at qty 0.
        removeCartRow(row);
        return;
      }
      row.dataset.cpQty = next;
      var valEl = row.querySelector('[data-cp-qty-val]');
      if (valEl) { valEl.style.opacity = '0'; setTimeout(function () { setQtyEl(valEl, next); valEl.style.opacity = '1'; }, 130); }
      vuoiQuantita(key, next);   // punti 4 e 5: la pagina si allinea all'evento
    });

    // Remove
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cp-remove]');
      if (!btn) return;
      var row = btn.closest('[data-cp-key]');
      if (!row) return;
      removeCartRow(row);
    });

    // Any cart change — including whole-gift-group deletions and changes
    // initiated from the header dropdown — re-syncs the full page: rows,
    // totals, free-shipping bar and empty state.
    updateCartPage();
    document.addEventListener(CHANGE_EVENT, updateCartPage);
    // ── Two-step empty ─────────────────────────────────────────────────────
    // Tap once: the button relabels itself to the confirm string it carries in
    // data-label-arm. Tap again: the bag empties. Tap anywhere else, press Esc,
    // or wait ARM_MS: it goes back. The two labels travel on the element as
    // data- attributes rendered by Liquid, so nothing here depends on
    // window.ZAGARA.i18n and theme.liquid is not touched.
    // The button lives inside #lxCartItems, which updateCartPage() already hides
    // at item_count 0 -- the empty state needs no extra logic.
    var CLEAR_ARM_MS = 6000;
    var clearArmed = null;

    function disarmClear(btn) {
      if (!btn) return;
      clearTimeout(btn._cpClearT);
      btn.classList.remove('is-arming');
      if (btn.dataset.labelIdle) btn.textContent = btn.dataset.labelIdle;
      if (clearArmed === btn) clearArmed = null;
    }

    document.addEventListener('click', function (e) {
      var btn = (e.target && e.target.closest) ? e.target.closest('[data-cp-clear]') : null;
      if (!btn) { disarmClear(clearArmed); return; }   // a click elsewhere always disarms
      if (btn.disabled) return;

      if (btn.classList.contains('is-arming')) {
        clearTimeout(btn._cpClearT);
        btn.disabled = true;
        // The button must never stay dead: if the callback never lands (a recovery
        // path that settles silently), this timer gives it back anyway.
        var safety = setTimeout(function () { btn.disabled = false; disarmClear(btn); }, 8000);
        apiClear(function () {
          clearTimeout(safety);
          btn.disabled = false;
          disarmClear(btn);
        });
        return;
      }

      disarmClear(clearArmed);
      btn.classList.add('is-arming');
      if (btn.dataset.labelArm) btn.textContent = btn.dataset.labelArm;
      clearArmed = btn;
      btn._cpClearT = setTimeout(function () { disarmClear(btn); }, CLEAR_ARM_MS);
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && clearArmed) disarmClear(clearArmed);
    });
  }

  function updateCartPage() {
    if (!cart) return;
    // Reconcile server-rendered rows against server truth: drop rows whose
    // line is gone (e.g. a whole gift group deleted with one click) and sync
    // quantity/line price on the rest.
    var byKey = {};
    cart.items.forEach(function (i) { byKey[i.key] = i; });
    document.querySelectorAll('[data-cp-key]').forEach(function (row) {
      if (row.dataset.cpRemoving) return; // removal in flight; its callback settles it
      var item = byKey[row.dataset.cpKey];
      if (!item) {
        collapseCartRow(row);
        setTimeout(function () { row.remove(); }, 580);
        return;
      }
      var q = quantitaMostrata(item);   // una quantita' voluta e non ancora mandata resta quella che si vede
      if (parseInt(row.dataset.cpQty, 10) !== q) {
        row.dataset.cpQty = q;
        var valEl = row.querySelector('[data-cp-qty-val]');
        if (valEl) setQtyEl(valEl, q);
      }
      var priceEl = row.querySelector('.cp-item__price');
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price);
    });
    var totalEl = document.getElementById('cpTotal');
    if (totalEl) animateValue(totalEl, formatMoneyWC(cart.total_price));
    // Show empty state
    if (cart.item_count === 0) {
      var items = document.getElementById('lxCartItems');
      var empty = document.getElementById('lxCartEmpty');
      var summary = document.getElementById('lxCartSummary');
      if (items) { items.style.opacity = '0'; setTimeout(function () { items.style.display = 'none'; }, 250); }
      if (summary) { summary.style.opacity = '0'; setTimeout(function () { summary.style.display = 'none'; }, 250); }
      if (empty) setTimeout(function () { empty.style.display = ''; }, 300);
    }
  }

  // ── Event wiring ──────────────────────────────────────────
  // Parte B, punto 8: al telefono l'icona apre /cart. Al tocco (pointerdown, prima del click) il browser comincia a prendere
  // /cart: regole di speculazione, solo prefetch (niente prerender); link prefetch dove non ci sono. Una volta per pagina.
  var cartPreso = false;
  function prendiCarrello() {
    if (cartPreso) return;
    cartPreso = true;
    var u = ROUTES.cart || '/cart';
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      var sr = document.createElement('script');
      sr.type = 'speculationrules';
      sr.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [u] }] });
      document.head.appendChild(sr);
    } else {
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = u;
      document.head.appendChild(l);
    }
  }

  function initToggle() {
    var toggles = cartToggles();
    if (!toggles.length) return;
    var closeTimer = null;
    function scheduleClose() {
      if (testataTelefono()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { if (dropdownOpen) closeDropdown(); }, 260);
    }
    toggles.forEach(function (toggle) {
      toggle.addEventListener('pointerdown', function () { if (testataTelefono()) prendiCarrello(); });
      toggle.addEventListener('click', function () {
        clearTimeout(hoverTimer);
        clearTimeout(closeTimer);
        if (testataTelefono()) { window.location.href = ROUTES.cart || '/cart'; return; }
        if (dropdownOpen) closeDropdown();
        else openDropdown();
      });
      /* il mouse apre quando si MUOVE sull'icona (come la tendina «Shop», luxury.js, initTendina; correzioni di
         t2-unione-f07, D3): mouseenter arriva anche quando e' la testata a tornare sotto il puntatore fermo, e la tendina
         aperta ferma la pagina */
      var entrato = false;
      toggle.addEventListener('mouseenter', function () {
        if (testataTelefono()) return;
        clearTimeout(closeTimer);
        entrato = true;
      });
      toggle.addEventListener('mousemove', function () {
        if (!entrato || testataTelefono()) return;
        entrato = false;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(openDropdown, 200);
      });
      toggle.addEventListener('mouseleave', function () {
        entrato = false;
        clearTimeout(hoverTimer);
        scheduleClose();
      });
    });
    // Keep the dropdown open while the cursor is over it; close shortly after leaving.
    var dd = document.getElementById('luxCartDropdown');
    if (dd) {
      dd.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      dd.addEventListener('mouseleave', scheduleClose);
    }
  }

  // Close on outside click
  document.addEventListener('pointerdown', function (e) {
    if (drawerOpen) {
      var panel = document.querySelector('#luxCartDrawer .lcd-panel');
      if (panel && !panel.contains(e.target)) closeDrawer();
    }
    if (dropdownOpen) {
      var dd = document.getElementById('luxCartDropdown');
      var onToggle = (e.target && e.target.closest) ? e.target.closest('[data-role="cart-toggle"]') : null;
      if (dd && !dd.contains(e.target) && !onToggle) closeDropdown();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (drawerOpen) closeDrawer(); if (dropdownOpen) closeDropdown(); }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lcd-close]')) { closeDrawer(); closeDropdown(); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    var key = btn.dataset.removeKey;
    var row = btn.closest('.lcd-dd-item, .lcd-line');
    if (row) {
      row.style.transition = 'opacity 220ms ease-in, transform 220ms ease-in';
      row.style.opacity    = '0';
      row.style.transform  = 'translateX(-28px)';
      row.dataset.lcdUscita = performance.now();
    }
    // La richiesta parte al clic, con la dissolvenza insieme (parte B, punto 3; prima dopo 230 ms). La riga sparisce al
    // disegno che segue la risposta, finita la dissolvenza; se il server rifiuta, torna com'era.
    annullaQuantita(key);
    rimozioni[key] = true;
    apiChange(key, 0, function () {
      delete rimozioni[key];
      var resta = cart && cart.items && cart.items.some(function (i) { return i.key === key; });
      if (resta) document.querySelectorAll('.lcd-dd-item, .lcd-line').forEach(function (n) { if (n.dataset.itemKey === key) ripristinaRiga(n); });
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-dec],[data-qty-inc]');
    if (!btn) return;
    var pill = btn.closest('[data-qty-key]');
    if (!pill) return;
    var key  = pill.dataset.qtyKey;
    var cur  = parseInt(pill.dataset.qtyVal, 10) || 1;
    var next = btn.hasAttribute('data-qty-dec') ? cur - 1 : cur + 1;
    if (next < 0) next = 0;
    pill.dataset.qtyVal = next;
    var valEl = pill.querySelector('.lcd-qty-pill__val');
    if (valEl) {
      valEl.style.opacity = '0';
      setTimeout(function () { valEl.textContent = next; valEl.style.opacity = '1'; }, 120);
    }
    // Una richiesta per riga, l'ultima quantita' voluta (punto 4); il disegno lo fa l'evento, una volta sola (punto 5).
    vuoiQuantita(key, next);
  });

  // Cross-tab sync. online-giro-01: un evento storage fa al massimo UNA lettura; quelli che arrivano mentre e' in volo ne chiedono una
  // sola alla fine. La lettura non avvisa le altre schede (accogli senza annuncia) e manda CHANGE_EVENT solo se il carrello e'
  // cambiato davvero.
  var altraInVolo = false, altraAncora = false;
  function daAltraScheda() {
    if (altraInVolo) { altraAncora = true; return; }
    altraInVolo = true;
    var fine = function () { altraInVolo = false; if (altraAncora) { altraAncora = false; daAltraScheda(); } };
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { accogli(data, fine); })
      .catch(function (err) { console.error('[zagara:cart] cart refresh failed', err); fine(); });
  }
  window.addEventListener('storage', function (e) {
    if (e.key !== 'zagara_cart_ts') return;
    daAltraScheda();   // l'evento ridisegna la tendina aperta: un disegno solo
  });

  document.addEventListener(CHANGE_EVENT, function () {
    updateBadge();
    if (drawerOpen) renderCartDrawer();
    if (dropdownOpen) renderDropdown();
  });

  // Giro finale, tappa 2, voce t2-soglia: passando nella testata del telefono (la finestra che si stringe sotto i 1152)
  // la tendina aperta si chiude, come il menu e la tendina «Shop» (luxury.js, allaSoglia). Li' l'icona apre /cart, e la
  // tendina restava aperta sull'icona del telefono col blocco della pagina: il passaggio del mouse non la chiude piu'
  // (scheduleClose esce sotto la soglia), restava ferma fino a un clic (banco: aperta a 1280, stretta a 1000: aperta,
  // contatore 1). Il fuoco rimasto dentro torna all'icona che si vede.
  (function () {
    var mq = window.ZAGARA && window.ZAGARA.testataTelefono;
    if (!mq) return;
    function passa() {
      if (!mq.matches || !dropdownOpen) return;
      var dd = document.getElementById('luxCartDropdown');
      var dentro = !!(dd && dd.contains(document.activeElement));
      closeDropdown();
      var t = visibleCartToggle();
      if (dentro && t) t.focus({ preventScroll: true });
    }
    if (mq.addEventListener) mq.addEventListener('change', passa);
    else if (mq.addListener) mq.addListener(passa);
  })();

  // rAF-batched: window drags fire resize every frame
  var resizeTicking = false;
  window.addEventListener('resize', function () {
    if (!dropdownOpen || resizeTicking) return;
    resizeTicking = true;
    requestAnimationFrame(function () {
      resizeTicking = false;
      if (dropdownOpen) positionDropdown();
    });
  });

  // lux-collection.js compatibility
  // online-giro-01: chi le chiama (ricerca, ricette, costruttore dei regali, ripieghi delle carte) lo fa dopo un'aggiunta del cliente:
  // la lettura avvisa le altre schede, se il carrello e' cambiato.
  window.openCartDrawer = function (productData) {
    fetchCart(function () { openDrawer(productData || null); }, false, true);
  };
  window.renderCart = function () {
    fetchCart(function () {
      updateBadge();
      if (dropdownOpen) renderDropdown();
    }, false, true);
  };
  window.updateCartCount = function () { fetchCart(null, false, true); };

  // ── Init ──────────────────────────────────────────────────
  // Parte B, punto 7: il carrello arriva con la pagina (layout/theme.liquid, <script type="application/json"
  // id="zg-cart-json">{{ cart | json }}) e si usa subito: prima ogni pagina chiedeva /cart.js e la tendina diceva «vuoto»
  // finche' non arrivava. Una rilettura al primo momento libero, e al ritorno dalla cache avanti/indietro (pageshow persisted),
  // tiene il carrello vero se e' cambiato in un'altra scheda. Senza il carrello in pagina: /cart.js, come prima.
  function cartDellaPagina() {
    var el = document.getElementById('zg-cart-json');
    if (!el) return null;
    try { var c = JSON.parse(el.textContent); return c && c.items ? c : null; } catch (e) { return null; }
  }

  function init() {
    initToggle();
    initProductPage();
    initCartPage();
    var c0 = cartDellaPagina();
    if (c0) {
      accogli(c0);   // pulizia dei regali orfani + CHANGE_EVENT, come dopo /cart.js
      if (window.requestIdleCallback) requestIdleCallback(rinfresca, { timeout: 4000 });
      else setTimeout(rinfresca, 2000);
    } else {
      fetchCart();
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) rinfresca(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.zagaraCart = {
    open:    openDrawer,
    close:   closeDrawer,
    refresh: function () { fetchCart(null, false, true); },
    add:     function (variantId, qty, cb, onError) { apiAdd(variantId, qty, cb, onError); },
    fly:     flyToCart
  };
})();
